RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const MAX_POSTS_IN_MODAL = 100;

    const PostsModal = views.PostsModal = RivalIQ.views.LayoutView.mixin({
        template: '#socialPostsModalTemplate',
        regions: {
            posts: '.x-posts'
        },

        ui: {
            modal: '.modal'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            modalBackdropResizing: RivalIQ.apps.Shell.views.ModalBackdropResizing
        },

        getModal: function () {
            const me = this;
            return me.ui.modal;
        },

        getModalBodyClientHeight: function () {
            const me = this;
            return me.posts?.el?.clientHeight;
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            const Widget = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.SOCIAL_POSTS);

            let metrics;
            if (_.includes([RivalIQ.enums.channels.TIKTOK, RivalIQ.enums.channels.YOUTUBE], me.getProp('channel'))) {
                metrics = [
                    'views',
                    'engagement_rate_by_view'
                ];
            } else {
                metrics = [
                    'engagement_total',
                    'engagement_rate'
                ];
            }

            const widget = new Widget(me.dashboardModel, {
                props: _.create(me.dashboardModel.attributes, {
                    // fake value to make widget render in details mode
                    widgetId: true,
                    // No post details modal unless showPostTagActionsInModal is set.
                    noClickThrough: !me.dashboardModel.getProp('showPostTagActionsInModal'),
                    sortable: true,
                    orderBy: [3],
                    metrics: metrics,
                    dimensions: []
                })
            });
            widget.widgetId = RivalIQ.enums.widgetTypes.SOCIAL_POSTS;

            me.posts.showWidget(widget, null, {
                forceLoadingView: true
            });
        },

        onRenderLoaded: function () {
            const me = this;

            if (me.getProp('showPostTagActionsInModal')) {
                $('.modal').attr('tabIndex', null);

                me._escapeListener = $(document).on('keydown', e => {
                    if (e.keyCode === 27) { // escape keycode
                        e.preventDefault();
                        me.$el.find('.modal').modal('hide');
                    }
                });
            }
        },

        onDestroy: function () {
            const me = this;

            if (me._escapeListener) {
                $(document).off('keydown', me._escapeListener);
                delete me._escapeListener;
            }
        },

        loadData: function () {
            const me = this;

            me.definition = new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id,
                dimensions: ['post'],
                property: 'id'
            });
            App.utils.updateMetric(me.definition, me.getProps());

            return me.definition.fetch()
                .then(function (results) {
                    me.metric = results;
                });
        },

        serializeData: function () {
            const me = this;
            const timePeriod = _.clone(me.getProp('timePeriod'));
            const channel = RivalIQ.data.channels.get(me.getProp('channel'));

            const numPostsShown = _.size(me.metric.getValue());
            const totalNumPosts = me.metric.clone({
                dimensions: [],
                property: 'count'
            }, {
                clobberDimensions: true
            }).getValue();

            return {
                channel: channel.get('name'),
                forName: me.getProp('forName'),
                timePeriod: RivalIQ.utils.timePeriod.rehydrate(timePeriod),
                modalTitle: me.getProp('modalTitle'),
                numPostsShownMetric: numPostsShown,
                totalNumPosts: totalNumPosts,
                postsForDimension: me.getProp('postsForDimension') || '',
                postWord: channel.get('postName')
            };
        },

        templateHelpers: function () {
            return {
                getFormattedDate: function (type) {
                    const data = this;
                    return data.timePeriod[type].format('MMM DD, YYYY');
                },
                isSingleDay: function () {
                    const data = this;
                    const startDate = data.timePeriod.mainPeriodStart;
                    const endDate = data.timePeriod.mainPeriodEnd;
                    return (Math.abs(endDate.diff(startDate, 'days')) < 1);
                }
            };
        }
    });

    /**
     * Shows a posts modal for a particular dashboardModel, source, company, and time period.
     * @param {Object} dashboardModel
     * @param {Number} source
     * @param {Object} company
     * @param {Object} [timePeriod]
     */
    PostsModal.show = function (props, source, company, timePeriod, compareAgainst) {
        let channel;
        // NOTE we have to do this regrettable dance because the
        // "Custom Chart Creator" does not have a channel set in the props of
        // its `dashboardModel`
        if (source !== RivalIQ.enums.sources.RIVALIQ && source !== RivalIQ.enums.sources.CROSS_CHANNEL) {
            channel = RivalIQ.data.channels.get(source).get('channel');
        }

        const defaultProps = {
            channel: channel
        };

        if (company) {
            defaultProps.companyIds = company.id;
            defaultProps.companyName = company.name;
        }

        if (compareAgainst) {
            props.forName = compareAgainst.name; //todo need the whole compare against.
            if (compareAgainst.benchmarkCompaniesFilter === RivalIQ.enums.benchmarkCompaniesFilters.exclude_focus_company.id) {
                props.companyIds = _(RivalIQ.state.landscape.getCompaniesByCompanySet(props.companySetDescriptor))
                    .map('id')
                    .without(props.focusCompanyId)
                    .value();
            }
        }

        props = _.defaults(defaultProps, props, {
            layout: 'list',
            forName: props.companyName
        });

        if (timePeriod) {
            props.timePeriod = RivalIQ.utils.timePeriod.toStatic(timePeriod);
        }

        props.isInPostTagEditMode = false;
        props.limit = MAX_POSTS_IN_MODAL;


        // TODO when a plan is devised for `dashboardModel` inheritance remove
        // this inline curation definition with that construct
        const curation = new RivalIQ.apps.Dashboard.models.Curation(null, props);

        // post tags need the router and id setup for nav to post tags manager.
        if (props.showPostTagActionsInModal) {
            curation.id = RivalIQ.curation.id;
            curation.router = RivalIQ.curation.router;
        }

        RivalIQ.execute('show:modal', new PostsModal({
            dashboardModel: curation
        }));
    };

});
